export default __webpack_public_path__ + "static/media/BrainBreak cards27.6d68d2cc.png";